import { Component } from "react";

/* Last line of defense — one bad section should never blank the whole site. */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { crashed: false };
  }

  static getDerivedStateFromError() {
    return { crashed: true };
  }

  componentDidCatch(error, info) {
    console.error("section crash contained:", error, info?.componentStack);
  }

  render() {
    if (this.state.crashed) {
      return (
        <main className="error-boundary-fallback" data-testid="error-boundary-fallback">
          <p className="rewards-eyebrow">SIGNAL FAULT // CONTAINED</p>
          <h1>THAT SECTION SHORTED OUT.</h1>
          <p>The rest of the wasteland is still standing.</p>
          <button type="button" className="button button-primary" onClick={() => window.location.reload()} data-testid="error-boundary-reload">
            RE-ESTABLISH SIGNAL
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
